"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var clearFormat_1 = require("./clearFormat");
/**
 * @deprecated Use clearFormat instead and pass the ClearFormatMode.Block as parameter
 * @param editor The editor instance
 */
function clearBlockFormat(editor) {
    clearFormat_1.default(editor, 1 /* Block */);
}
exports.default = clearBlockFormat;
//# sourceMappingURL=clearBlockFormat.js.map